var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.400146,
    width: 52,
    height: 52,
    rx: 20,
    fill: "#CFF47F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3393_20087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4001 24C28.4381 24 24.4001 28.038 24.4001 33C24.4001 37.962 28.4381 42 33.4001 42C38.3621 42 42.4001 37.962 42.4001 33C42.4001 28.038 38.3621 24 33.4001 24Z",
    fill: "#2E7D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4001 28.1504C33.8693 28.1504 34.2498 28.5308 34.2498 29V32.6484L37.0017 35.4004C37.3327 35.7314 37.3339 36.2679 37.0027 36.6016C36.8356 36.7669 36.6178 36.8496 36.4001 36.8496C36.1824 36.8496 35.9646 36.7669 35.7976 36.6016H35.7986L32.7986 33.6016H32.7976C32.6397 33.4414 32.5505 33.2255 32.5505 33V29C32.5505 28.5308 32.931 28.1504 33.4001 28.1504Z",
    fill: "#CFF47F",
    stroke: "#2E7D32",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1501 29.0381C23.0761 28.9541 23.0161 28.8581 22.9361 28.7781L20.4001 26.2441L17.8641 28.7801C16.9201 29.7221 16.4001 30.9761 16.4001 32.3141V34.0021H22.4501C22.4201 33.6721 22.4001 33.3381 22.4001 33.0001C22.4001 31.6021 22.6721 30.2701 23.1501 29.0381Z",
    fill: "#2E7D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4001 14V15.686C16.4001 17.02 16.9201 18.276 17.8641 19.222L20.4001 21.758L22.9361 19.222C23.8801 18.278 24.4001 17.022 24.4001 15.686V14H16.4001Z",
    fill: "#2E7D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4001 10.1504H29.4001C29.8693 10.1504 30.2498 10.5308 30.2498 11C30.2498 11.4692 29.8693 11.8496 29.4001 11.8496H28.2498V15.6855C28.2498 17.902 27.4412 19.9934 25.9626 21.6221L25.658 21.9414V21.9424L23.7078 23.8936L23.6023 24L23.7078 24.1064L25.1394 25.5371C24.7559 25.9613 24.406 26.413 24.0906 26.8916L21.7986 24.6016H21.7976C21.6397 24.4414 21.5505 24.2255 21.5505 24C21.5505 23.7764 21.6393 23.5597 21.7976 23.3994L21.7986 23.4004L24.4558 20.7422C25.8058 19.3901 26.5505 17.5954 26.5505 15.6855V11.8496H14.2498V15.6855C14.2498 17.4759 14.9042 19.1666 16.0984 20.4834L16.3445 20.7422L19.0017 23.3984V23.3975C19.1601 23.5576 19.2498 23.7759 19.2498 24C19.2498 24.1979 19.181 24.3882 19.0574 24.54L19.0017 24.6016L16.3445 27.2578C14.9945 28.6099 14.2498 30.4046 14.2498 32.3145V36.1504H14.4001L22.7146 36.1484C22.8882 36.7373 23.1102 37.3038 23.3748 37.8477L11.4001 37.8496L11.3132 37.8457C10.8848 37.8021 10.5505 37.4398 10.5505 37C10.5505 36.5308 10.931 36.1504 11.4001 36.1504H12.5505V32.3145C12.5505 30.098 13.3588 28.0078 14.8376 26.376L15.1423 26.0557L17.0925 24.1064L17.198 24L17.0925 23.8936L15.1423 21.9443C13.4705 20.2725 12.5505 18.0498 12.5505 15.6855V11.8496H11.4001C10.9308 11.8496 10.5505 11.471 10.5505 11C10.5505 10.5326 10.9312 10.1504 11.4001 10.1504Z",
    fill: "#2E7D32",
    stroke: "#CFF47F",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3393_20087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(10.4001 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.2d811dc1abdb9c1a98e3e35d9e4df9ec.svg";
export { ForwardRef as ReactComponent };